import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PoModalModule, PoPageModule, PoWidgetModule, PoFieldModule, PoButtonModule, PoContainerModule, PoLoadingModule, PoModalAction, PoModalComponent, PoNotificationService } from '@po-ui/ng-components';
import { TokenService } from '../shared/service/token.service';
import { ApiService } from '../shared/service/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-branch-select',
  imports:
    [FormsModule,
      PoModalModule,
      PoPageModule,
      PoWidgetModule,
      PoFieldModule,
      PoButtonModule,
      PoContainerModule,
      CommonModule,
      PoLoadingModule],
  templateUrl: './modal-branch-select.component.html',
  styleUrl: './modal-branch-select.component.css'
})
export class ModalBranchSelectComponent {
  @ViewChild('modal', { static: false }) private modal!: PoModalComponent;
  @Output() selected = new EventEmitter<string>();
  @Output() cancel = new EventEmitter();
  branchList: any = [{ label: 'default', value: '0' }];
  branchSelected: string = '';
  size = 'sm';
  text = 'Carregando';
  isLoading: boolean = false;
  removeInitialFilter = true;
  primaryActionBranch: PoModalAction = {
    action: () => {
      if (!isNaN(Number(this.branchSelected))) {
        this.confirm();
      }
    },
    label: 'Confirmar'
  };
  secondaryActionBranch: PoModalAction = {
    action: () => {
      this.modal.close();
      this.exit();
    },
    label: 'Sair'
  };

  constructor(
    private tokenService: TokenService,
    private poNotification: PoNotificationService,
    private api: ApiService,
    private router: Router,
  ) { }

  async open() {
    var shouldOpen = await this.recoverTerminalList();
    if (shouldOpen) {
      this.modal.open();
      return;
    }

    this.selected.emit(this.branchSelected);
    return;
  }

  private recoverTerminalList(): Promise<boolean> {
    return new Promise((resolve) => {
      this.isLoading = true;
      this.recoverBranchs()
        .subscribe({
          next: (data: any) => {
            this.branchList = [];
            data.items.map((item: any) => {
              this.branchList.push({ label: item.branchCode.toString() + ' - ' + item.personName, value: item.branchCode })
            });
          },
          error: () => {
            this.poNotification.warning("Não foi possível obter as empresas para o usuário.");
            this.isLoading = false;
            return resolve(false);
          },
          complete: () => {
            this.isLoading = false;

            if (this.branchList.length == 0) {
              this.poNotification.warning("Não há empresas liberadas para este usuário.");
              this.exit();
              this.modal.close();
              return resolve(false);
            }

            return resolve(true);
          }
        });
    });
  }

  recoverBranchs() {
    return this.api.getBranchList();
  }

  protected setBranch(event: any) {
    if (event == undefined)
      return;

    this.branchSelected = event;
    this.tokenService.saveBranch(event);
    const branchName = this.branchList.find((item: any) => item.value == event);
    this.tokenService.saveBranchName(branchName.label);
  }

  confirm() {
    this.selected.emit(this.branchSelected);
    this.poNotification.success('Alterado com sucesso.');
    this.modal.close();
    window.location.reload();
  }

  exit() {
    this.cancel.emit();
  }
}
